import React from 'react';
import PropTypes from 'prop-types';
import * as S from './PageStyled';

/** Declarative container for the Page (top-most) Header Area (i.e: Title, Tabs, Create, and more items) */
export const PageHeader = ({ children }) => <S.Header>{children}</S.Header>;
PageHeader.propTypes = {
  children: PropTypes.node
};

/** Declarative container for the Page Top Panel.
 * Below the Header and above the Content
 * suitable for Summary information, widgets, ...
 * @param children - the direct children elements
 * @param visible - optional - sets if the item is visible or not (can be used in case un/mounting is not efficient)
 * @param collapsible - optional - when true, Page renders a collapse/expand toggle pinned to the
 *   bottom-center edge of the panel. Page owns the collapsed/expanded state internally.
 * @param toggleTestId - optional - data-testid for the toggle
 * Note: collapsible/toggleTestId are consumed by the parent Page (which owns the positioning context),
 * same as `visible` — they are not rendered by PageTopPanel itself. */
export const PageTopPanel = ({ children, visible }) => <S.TopPanel visible={visible}>{children}</S.TopPanel>;
PageTopPanel.propTypes = {
  visible: PropTypes.bool,
  collapsible: PropTypes.bool,
  toggleTestId: PropTypes.string,
  children: PropTypes.node
};

/** Declarative container for Page main content (Table, Form, Dashboards, ...) */
export const PageContent = ({ children }) => <S.Content>{children}</S.Content>;
PageContent.propTypes = {
  children: PropTypes.node
};

/** Declarative container for header above the main content (Summary, filters, search, paginate, create, ...)
 * It can be skipped if the top content header () is included inside the PageContent components.
 * But then if the left and right blades are opened, they will hide the header (as it part of the content). */
export const PageContentHeader = ({ children }) => <S.MainAreaHeader>{children}</S.MainAreaHeader>;
PageContentHeader.propTypes = {
  children: PropTypes.node
};

/** Declarative container for Page Content Left Panel (Filter, Navigation, Menu ...)
 * @param children - the direct children elements
 * @param visible - optional - sets if the item is visible or not (can be used in case un/mounting is not efficient) */
export const PageContentLeft = ({ children, visible, floating = false }) => (
  <S.LeftDrawer visible={visible} $floating={floating}>
    {children}
  </S.LeftDrawer>
);
PageContentLeft.propTypes = {
  visible: PropTypes.bool,
  floating: PropTypes.bool,
  children: PropTypes.node
};

/** Declarative container for Page Content Right Panel (Details, Drawer, ...)
 * @param children - the direct children elements
 * @param visible - optional - sets if the item is visible or not (can be used in case un/mounting is not efficient) */
export const PageContentRight = ({ children, visible, floating = true }) => (
  <S.RightDrawer visible={visible} $floating={floating}>
    {children}
  </S.RightDrawer>
);
PageContentRight.propTypes = {
  visible: PropTypes.bool,
  floating: PropTypes.bool,
  children: PropTypes.node
};

/** Declarative container for Page Content Bottom Panel (Bulk Actions, Selection Summary, ...)
 * @param children - the direct children elements
 * @param visible - optional - sets if the item is visible or not (can be used in case un/mounting is not efficient) */
export const PageContentBottom = ({ children, visible }) => (
  <S.BottomDrawer visible={visible}>{children}</S.BottomDrawer>
);
PageContentBottom.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node
};
